import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import sealQuestionIcon from "@phosphor-icons/core/regular/seal-question.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const questionsGenerator: Tool = {
    urlSlug: "questions-generator",
    configName: "teacher-tool-questions-generator",
    title: () => t`Questions generator`,
    description: () => t`Create questions for a specific piece of content`,
    categories: [ToolCategories.Create, ToolCategories.Plan],
    icon: sealQuestionIcon,
    color: color.fadedGreen24,
    layout: Layout.Coeditor,
    reportingLabelId: "questions-generator",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
        "google-forms",
    ],
    requestedInputs: [
        {
            description: () => "",
            inputKind: "SINGLE_SELECT",
            label: () => t`Grade level`,
            required: true,
            selectOptions: [
                {
                    label: () => t`1st grade`,
                    value: "1st grade",
                },
                {
                    label: () => t`2nd grade`,
                    value: "2nd grade",
                },
                {
                    label: () => t`3rd grade`,
                    value: "3rd grade",
                },
                {
                    label: () => t`4th grade`,
                    value: "4th grade",
                },
                {
                    label: () => t`5th grade`,
                    value: "5th grade",
                },
                {
                    label: () => t`6th grade`,
                    value: "6th grade",
                },
                {
                    label: () => t`7th grade`,
                    value: "7th grade",
                },
                {
                    label: () => t`8th grade`,
                    value: "8th grade",
                },
                {
                    label: () => t`9th grade`,
                    value: "9th grade",
                },
                {
                    label: () => t`10th grade`,
                    value: "10th grade",
                },
                {
                    label: () => t`11th grade`,
                    value: "11th grade",
                },
                {
                    label: () => t`12th grade`,
                    value: "12th grade",
                },
                {
                    label: () => t`College`,
                    value: "College",
                },
            ],
            variableName: "gradeLevel",
        },
        {
            description: () => t`1 - 10`,
            inputKind: "TEXT_BOX",
            label: () => t`Number of questions`,
            required: true,
            variableName: "numberOfQuestions",
        },
        {
            description: () =>
                t`Input the text for which you'd like to generate questions (4,500 words or less).`,
            inputKind: "TEXT_AREA",
            label: () => t`Text`,
            required: true,
            variableName: "inputText",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
                renderer="quiz"
            />
        );
    },
};
